import { useQuery, useMutation } from '@apollo/client';
import { GET_APPOINTMENT_AGORA_LINK, GENERATE_AGORA_TOKEN, VALIDATE_AGORA_TOKEN } from '../graphql/queries';

export interface AgoraLinkData {
  id: string;
  appointmentId: string;
  channelName: string;
  uid: string;
  role: string;
  token: string;
  link: string;
  webLink: string;
  appId: string;
  expiresAt: Date;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export const useAppointmentAgoraLink = (appointmentId: string) => {
  const { data, loading, error, refetch } = useQuery(GET_APPOINTMENT_AGORA_LINK, {
    variables: {
      input: {
        appointmentId,
      },
    },
    skip: !appointmentId,
  });

  return {
    agoraLink: data?.getAppointmentAgoraLink as AgoraLinkData | undefined,
    loading,
    error,
    refetch,
  };
};

export const useGenerateAgoraToken = () => {
  const [generateToken, { loading, error }] = useMutation(GENERATE_AGORA_TOKEN);

  const generateTokenForChannel = async (
    channelName: string,
    uid: string,
    role: 'publisher' | 'subscriber' = 'publisher',
    privilegeExpiredTs?: number
  ) => {
    try {
      const { data } = await generateToken({
        variables: {
          input: {
            channelName,
            uid,
            role,
            privilegeExpiredTs,
          },
        },
      });
      return data?.generateAgoraToken;
    } catch (err) {
      console.error('Failed to generate Agora token:', err);
      throw err;
    }
  };

  return {
    generateToken: generateTokenForChannel,
    loading,
    error,
  };
};

export const useValidateAgoraToken = () => {
  const [validateToken, { loading, error }] = useMutation(VALIDATE_AGORA_TOKEN);

  const validateTokenForChannel = async (
    token: string,
    channelName: string,
    uid: string
  ) => {
    try {
      const { data } = await validateToken({
        variables: {
          input: {
            token,
            channelName,
            uid,
          },
        },
      });
      return data?.validateAgoraToken;
    } catch (err) {
      console.error('Failed to validate Agora token:', err);
      throw err;
    }
  };

  return {
    validateToken: validateTokenForChannel,
    loading,
    error,
  };
}; 